(function () {
  if (window.__quickBuyInitialized) return;
  window.__quickBuyInitialized = true;

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  // Requests the section HTML in the same call (like product-form.js and the
  // drawer's upsell add do) instead of a separate refresh() round trip afterwards.
  function addToCart(variantId, drawer) {
    const payload = { id: variantId, quantity: 1 };
    if (drawer) {
      payload.sections = drawer.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }
    return fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then((response) => response.json());
  }

  function afterAdd(response, drawer) {
    if (drawer) {
      const sectionHtml = response && response.sections && response.sections['cart-drawer'];
      if (sectionHtml) {
        drawer.renderContents(response);
        return Promise.resolve();
      }
      return drawer.refresh().then(() => drawer.open());
    }
    return fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle('bubble-hidden', cart.item_count === 0);
        });
      });
  }

  function handleSingleAdd(button) {
    if (button.disabled || button.classList.contains('is-loading')) return;
    const variantId = button.dataset.fqbSingleAdd;
    button.classList.add('is-loading');

    const drawer = cartDrawer();
    const title = button.dataset.productTitle;
    if (drawer && title) {
      drawer.addOptimisticItem({
        variantId,
        title,
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || '',
        priceCents: Number(button.dataset.productPriceCents) || 0,
        quantity: 1,
      });
    }

    addToCart(variantId, drawer)
      .then((response) => {
        if (response.status) {
          drawer?.removeOptimisticItem?.();
          console.error(response.description || response.message);
          return;
        }
        return afterAdd(response, drawer);
      })
      .catch((e) => {
        drawer?.removeOptimisticItem?.();
        console.error(e);
      })
      .finally(() => button.classList.remove('is-loading'));
  }

  function openModal(productId) {
    const modal = document.getElementById(`fqb-modal-${productId}`);
    if (!modal) return;
    modal.hidden = false;
    modal._selectedOptions = {};
    modal._selectedVariantId = null;
    modal._selectedVariant = null;
    modal.querySelectorAll('.fqb-modal__option-btn').forEach((btn) => btn.classList.remove('is-selected'));
    const addBtn = modal.querySelector('[data-fqb-add]');
    if (addBtn) addBtn.disabled = true;
  }

  function closeModal(productId) {
    const modal = document.getElementById(`fqb-modal-${productId}`);
    if (!modal) return;
    modal.hidden = true;
  }

  function getVariants(productId) {
    const script = document.querySelector(`script[data-fqb-variants="${productId}"]`);
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function handleOptionSelect(modal, button) {
    const pos = button.dataset.optionPos;
    const value = button.dataset.optionVal;

    modal
      .querySelectorAll(`.fqb-modal__option-btn[data-option-pos="${pos}"]`)
      .forEach((btn) => btn.classList.remove('is-selected'));
    button.classList.add('is-selected');

    modal._selectedOptions = modal._selectedOptions || {};
    modal._selectedOptions[pos] = value;

    const productId = modal.id.replace('fqb-modal-', '');
    const variants = getVariants(productId);
    const optionGroupCount = modal.querySelectorAll('.fqb-modal__option-group').length;
    const selectedCount = Object.keys(modal._selectedOptions).length;

    const addBtn = modal.querySelector('[data-fqb-add]');
    if (selectedCount < optionGroupCount) {
      modal._selectedVariantId = null;
      if (addBtn) addBtn.disabled = true;
      return;
    }

    const match = variants.find((variant) =>
      variant.options.every((optionValue, index) => modal._selectedOptions[index + 1] === optionValue)
    );

    if (match && match.available) {
      modal._selectedVariantId = match.id;
      modal._selectedVariant = match;
      if (addBtn) addBtn.disabled = false;
    } else {
      modal._selectedVariantId = null;
      modal._selectedVariant = null;
      if (addBtn) addBtn.disabled = true;
    }
  }

  function handleModalAdd(button) {
    const modal = button.closest('.fqb-modal');
    if (!modal || !modal._selectedVariantId || button.disabled) return;

    button.disabled = true;
    button.classList.add('fqb-modal__add-btn--loading');

    const drawer = cartDrawer();
    const variant = modal._selectedVariant;
    const title = modal.querySelector('.fqb-modal__title')?.textContent;
    if (drawer && title && variant) {
      drawer.addOptimisticItem({
        variantId: modal._selectedVariantId,
        title,
        image: variant.image || '',
        price: variant.price || '',
        priceCents: Number(variant.priceCents) || 0,
        quantity: 1,
      });
    }

    addToCart(modal._selectedVariantId, drawer)
      .then((response) => {
        if (response.status) {
          drawer?.removeOptimisticItem?.();
          console.error(response.description || response.message);
          return;
        }
        closeModal(modal.id.replace('fqb-modal-', ''));
        return afterAdd(response, drawer);
      })
      .catch((e) => {
        drawer?.removeOptimisticItem?.();
        console.error(e);
      })
      .finally(() => {
        button.disabled = false;
        button.classList.remove('fqb-modal__add-btn--loading');
      });
  }

  document.addEventListener('click', (evt) => {
    const singleAddBtn = evt.target.closest('[data-fqb-single-add]');
    if (singleAddBtn) {
      handleSingleAdd(singleAddBtn);
      return;
    }

    const openBtn = evt.target.closest('[data-fqb-open]');
    if (openBtn) {
      openModal(openBtn.dataset.fqbOpen);
      return;
    }

    const closeBtn = evt.target.closest('[data-fqb-close]');
    if (closeBtn) {
      closeModal(closeBtn.dataset.fqbClose);
      return;
    }

    const optionBtn = evt.target.closest('.fqb-modal__option-btn');
    if (optionBtn) {
      const modal = optionBtn.closest('.fqb-modal');
      if (modal) handleOptionSelect(modal, optionBtn);
      return;
    }

    const addBtn = evt.target.closest('[data-fqb-add]');
    if (addBtn) {
      handleModalAdd(addBtn);
    }
  });
})();
